export default "__VITE_ASSET__COPY0XoZ__ 400w, __VITE_ASSET__BpEeSWPN__ 800w, __VITE_ASSET__BuJ8JePJ__ 1280w";